import { nest } from "d3-collection";
import { formatNumber, formatPercent, modularTextSVG } from "sszvis";
export const toArray = (x) => x === undefined ? [] : Array.isArray(x) ? x : [x];
/** Smooth Scroller */
const getTop = (element, start) => element.nodeName === "HTML"
    ? -start
    : element.getBoundingClientRect().top + start;
const easeInOutCubic = (t) => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
const position = (start, end, elapsed, duration) => elapsed > duration
    ? end
    : start + (end - start) * easeInOutCubic(elapsed / duration);
const toElement = (selectorOrElement) => {
    if (typeof selectorOrElement === "string") {
        return document.querySelector(selectorOrElement);
    }
    else {
        return selectorOrElement;
    }
};
export const smoothScroll = (selectorOrElement, duration = 500) => {
    const el = toElement(selectorOrElement);
    if (el === null) {
        return Promise.reject(new Error(`Element '${selectorOrElement}' not found`));
    }
    const clock = window.performance.now();
    const start = window.pageYOffset;
    const end = getTop(el, start);
    return new Promise(resolve => {
        const step = () => {
            const elapsed = window.performance.now() - clock;
            window.scroll(0, position(start, end, elapsed, duration));
            if (elapsed > duration) {
                resolve();
            }
            else {
                requestAnimationFrame(step);
            }
        };
        step();
    });
};
/** Number Formatting */
export const formatNumberByUnit = (number, unit) => {
    switch (unit) {
        case "Percent":
            return formatPercent(number);
        default:
            return formatNumber(number);
    }
};
/** Annotation Formatting */
export const formatNumberByUnitLabel = (val, label) => {
    const rulerLabel = modularTextSVG()
        .bold(val)
        .plain(label);
    return rulerLabel();
};
/** Geography */
export const locations = [
    {
        locationID: "R20000",
        locationName: "Stadt nach 1. Eingemeindung 1893",
        geoEntityName: "Stadt nach 1. Eingemeindung 1893",
        geoEntityID: "HZH"
    },
    {
        locationID: "R00400",
        locationName: "Kreis VI",
        geoEntityName: "Historische Kreise",
        geoEntityID: "HKR"
    },
    {
        locationID: "R01000",
        locationName: "Kreis VII",
        geoEntityName: "Historische Kreise",
        geoEntityID: "HKR"
    },
    {
        locationID: "R30000",
        locationName: "Stadt Zürich",
        geoEntityName: "Stadt Zürich",
        geoEntityID: "ZH"
    },
    {
        locationID: "R10000",
        locationName: "Kreis 1",
        geoEntityName: "Kreise",
        geoEntityID: "KR"
    },
    {
        locationID: "R00200",
        locationName: "Kreis 2",
        geoEntityName: "Kreise",
        geoEntityID: "KR"
    },
    {
        locationID: "R00600",
        locationName: "Kreis 3",
        geoEntityName: "Kreise",
        geoEntityID: "KR"
    },
    {
        locationID: "R00700",
        locationName: "Kreis 4",
        geoEntityName: "Kreise",
        geoEntityID: "KR"
    },
    {
        locationID: "R00800",
        locationName: "Kreis 5",
        geoEntityName: "Kreise",
        geoEntityID: "KR"
    },
    {
        locationID: "R01200",
        locationName: "Kreis 6",
        geoEntityName: "Kreise",
        geoEntityID: "KR"
    },
    {
        locationID: "R01300",
        locationName: "Kreis 7",
        geoEntityName: "Kreise",
        geoEntityID: "KR"
    },
    {
        locationID: "R01100",
        locationName: "Kreis 8",
        geoEntityName: "Kreise",
        geoEntityID: "KR"
    },
    {
        locationID: "R01400",
        locationName: "Kreis 9",
        geoEntityName: "Kreise",
        geoEntityID: "KR"
    },
    {
        locationID: "R01500",
        locationName: "Kreis 10",
        geoEntityName: "Kreise",
        geoEntityID: "KR"
    },
    {
        locationID: "R01600",
        locationName: "Kreis 11",
        geoEntityName: "Kreise",
        geoEntityID: "KR"
    },
    {
        locationID: "R01800",
        locationName: "Kreis 11",
        geoEntityName: "Kreise",
        geoEntityID: "KR"
    },
    {
        locationID: "R01700",
        locationName: "Kreis 12",
        geoEntityName: "Kreise",
        geoEntityID: "KR"
    },
    {
        locationID: "R00011",
        locationName: "Rathaus",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00012",
        locationName: "Hochschulen",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00013",
        locationName: "Lindenhof",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00014",
        locationName: "City",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00021",
        locationName: "Wollishofen",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00023",
        locationName: "Leimbach",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00024",
        locationName: "Enge",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00031",
        locationName: "Alt-Wiedikon",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00033",
        locationName: "Friesenberg",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00034",
        locationName: "Sihlfeld",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00041",
        locationName: "Werd",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00042",
        locationName: "Langstrasse",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00044",
        locationName: "Hard",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00051",
        locationName: "Gewerbeschule",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00052",
        locationName: "Escher Wyss",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00061",
        locationName: "Unterstrass",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00063",
        locationName: "Oberstrass",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00071",
        locationName: "Fluntern",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00072",
        locationName: "Hottingen",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00073",
        locationName: "Hirslanden",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00074",
        locationName: "Witikon",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00081",
        locationName: "Seefeld",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00082",
        locationName: "Mühlebach",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00083",
        locationName: "Weinegg",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00091",
        locationName: "Albisrieden",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00092",
        locationName: "Altstetten",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00101",
        locationName: "Höngg",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00102",
        locationName: "Wipkingen",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00111",
        locationName: "Affoltern",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00115",
        locationName: "Oerlikon",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00119",
        locationName: "Seebach",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00121",
        locationName: "Saatlen",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00122",
        locationName: "Schwamendingen-Mitte",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R00123",
        locationName: "Hirzenbach",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R06001",
        locationName: "Affoltern",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    },
    {
        locationID: "R06002",
        locationName: "Albisrieden",
        geoEntityName: "Quartiere",
        geoEntityID: "QR"
    }
];
export const locationsByEntity = nest()
    .key((d) => d.geoEntityID)
    .object(locations);
export const indexBy = (key, data) => {
    let grouped = {};
    for (let i = 0; i < data.length; i++) {
        let k = key(data[i]);
        grouped[k] = data[i];
    }
    return grouped;
};



// WEBPACK FOOTER //
// ./src/util.ts